import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { Link } from "react-router-dom";
import { Package, Scissors, ChevronRight } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

export default function Orders() {
  const [data, setData] = useState({ orders: [], bespoke: [] });
  useEffect(() => { api.get("/orders").then(({ data }) => setData(data)).catch(() => {}); }, []);

  const all = [...(data.bespoke || []).map((o) => ({ ...o, _bespoke: true })), ...(data.orders || []).map((o) => ({ ...o, _bespoke: false }))]
    .sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));

  return (
    <main className="sq-container py-12" data-testid="orders-page">
      <div className="sq-eyebrow text-squire-jeans">Your Account</div>
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <h1 className="font-display text-4xl md:text-5xl mt-2">My Orders</h1>
        <Link to="/returns" data-testid="orders-returns-link" className="text-sm border border-black/20 hover:border-black rounded-full px-4 py-2 transition-colors">Return / Alteration</Link>
      </div>

      <div className="mt-8 space-y-4 max-w-3xl">
        {all.length === 0 && (
          <div className="border border-black/10 rounded-lg p-10 text-center">
            <div className="text-[#4B5563]">You have no orders yet.</div>
            <Link to="/bespoke" className="sq-btn-primary inline-flex mt-4">Start a bespoke order</Link>
          </div>
        )}

        {all.map((o, i) => (
          <Link key={o.id} to={`/track-order?id=${o.id}`} data-testid={`order-${o.id}`}
            style={{ animationDelay: `${i * 50}ms` }}
            className={`flex items-center gap-4 border rounded-lg p-5 hover:-translate-y-0.5 hover:shadow-md transition-all duration-200 animate-in fade-in-0 slide-in-from-bottom-2 ${o._bespoke ? "border-squire-jeans/40 bg-squire-jeans/[0.03]" : "border-black/10"}`}>
            <div className={`w-10 h-10 rounded-full grid place-items-center shrink-0 ${o._bespoke ? "bg-squire-jeans/10 text-squire-jeans" : "bg-black/5 text-black"}`}>
              {o._bespoke ? <Scissors size={18} /> : <Package size={18} />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-3">
                <span className="font-display text-lg truncate">{o.id}{o._bespoke ? ` · Bespoke ${o.garment_type || ""}` : ""}</span>
                <span className="font-semibold whitespace-nowrap">{formatINR(o.total)}</span>
              </div>
              <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                <StatusBadge status={o.stage || o.status || "placed"} />
                {o.balance_due > 0 && <span className="text-[11px] text-amber-700">balance {formatINR(o.balance_due)}</span>}
                {o.payment_status === "paid" && o.balance_due === 0 && <StatusBadge status="paid in full" />}
                <span className="text-[11px] text-[#9CA3AF]">{o.created_at ? o.created_at.slice(0, 10) : ""}</span>
              </div>
            </div>
            <ChevronRight size={18} className="text-[#9CA3AF] shrink-0" />
          </Link>
        ))}
      </div>
    </main>
  );
}
